// extracted by mini-css-extract-plugin
module.exports = {"pagerContainer":"pager_pagerContainer__V5xgj","dirWrapper":"pager_dirWrapper__C4DfB","dirWrapper--prev":"pager_dirWrapper--prev__sVWyV"};